// extracted by css-extract-rspack-plugin
export default {"BrandCircle":"LLe27","IconMargin":"rD80B"};